export function TenjinSlugify(string) {
  const a =
    "àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;"
  const b =
    "aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------"
  const p = new RegExp(a.split("").join("|"), "g")

  return (
    string
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
      .replace(/&/g, "-and-") // Replace & with 'and'
      //eslint-disable-next-line
      .replace(/[^\w\-]+/g, "") // Remove all non-word characters
      //eslint-disable-next-line
      .replace(/\-\-+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, "")
  ) // Trim - from end of text
}

export function getClosest(elem, selector) {
  while (elem.tagName !== selector) {
    if (elem.target) elem = elem.target.parentNode
    else if (elem.parentNode) elem = elem.parentNode
  }
  return elem ? elem.parentNode.parentNode.children[0].innerText : null
}

export function CopyToClipboard(text) {
  var textArea = document.createElement("textarea")
  textArea.innerHTML = text
  textArea.value = text
  textArea.style.top = "0"
  textArea.style.left = "0"
  textArea.style.position = "fixed"

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand("copy")
  } catch (err) {
    console.error("Fallback: Oops, unable to copy", err)
  }

  document.body.removeChild(textArea)
}

export function searchCards(searchIndex, searchQuery, allCards) {
  let  searchResults = [], foundCards = [];

  searchResults = searchIndex.search(`*${searchQuery}*`);

  searchResults.map((searchResultEl, index) => {
    const card = allCards.find(
      cardEl => cardEl.node.id === searchResultEl.ref,
    );
    if (card) {
      foundCards.push(card);
    }
    return searchResultEl;
  });

  return foundCards;
}

export function filterByCategory(cardsToDisplay, categoryFilter) {
  return cardsToDisplay.filter(el => {
    if (categoryFilter === null) {
      return true;
    }

    return (
      el.node.categories?.nodes.length > 0 &&
      el.node.categories?.nodes.some(cat => cat.slug === categoryFilter)
    );
  });
}

export function sortCards(cards, sortFilter) {
  switch (sortFilter) {
    case 'free':
     for (var i = cards.length - 1; i >= 0; i--) {
        if ( cards[i].node.acf.tenjinPaidContent === 'paid' ) {
          cards.splice(i, 1)
        }
      }
      break;
    case 'paid':
      for (var j = cards.length - 1; j >= 0; j--) {
        if ( cards[j].node.acf.tenjinPaidContent !== 'paid' ) {
          cards.splice(j, 1)
        }
      }
      break;
    case 'upcoming':
      for (var k = cards.length - 1; k >= 0; k--) {
        if (cards[k].node.acf.tenjinUpcomingContent !== true) {
         cards.splice(k, 1)
        }
      }
      break;
    case 'popular':
      cards.sort((t1, t2) => {
        const pop1 = t1.node.acf.tenjinPopularity;
        const pop2 = t2.node.acf.tenjinPopularity;
        if (pop1 < pop2) {
          return 1;
        } else if (pop1 > pop2) {
          return -1;
        }
        return 0;
      });
      break;
    case 'aToZ':
      cards.sort((t1, t2) => {
        const title1 = t1.node.title.toUpperCase();
        const title2 = t2.node.title.toUpperCase();

        if (title1 > title2) {
          return 1;
        } else if (title1 < title2) {
          return -1;
        }

        return 0;
      });
      break;
    case 'zToA':
      cards.sort((t1, t2) => {
        const title1 = t1.node.title.toUpperCase();
        const title2 = t2.node.title.toUpperCase();

        if (title2 > title1) {
          return 1;
        } else if (title2 < title1) {
          return -1;
        }

        return 0;
      });
      break;
    case 'new':
      cards.sort((t1, t2) => {
        const date1 = t1.node.date.toUpperCase();
        const date2 = t2.node.date.toUpperCase();

        if (date1 < date2) {
          return 1;
        } else if (date1 > date2) {
          return -1;
        }

        return 0;
      });
      break;
    default:
      break;
  }
}
